// extracted by mini-css-extract-plugin
export default {"topLabel":"_1DEMP8a-O2AtTK1rKPYFpE","bottomLabel":"_2Mkq2N35h7xEyEBe77IADz","selectedInvoiceShortfallPaddingBottom":"akP23RV81Zo16Yw94B9WD","column":"_9c-z0MNpnRt_p9mek9vCO"};